import React, { useRef } from "react";
import type { MessageSource } from "../models.ts";
import ContextMenu, { ContextMenuItem } from "./ContextMenu/index.ts";

interface MessageSourcesProps {
  sources?: MessageSource[];
}

export function MessageSources({ sources }: MessageSourcesProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  if (!sources || sources.length === 0) return null;

  const maxVisible = 5;
  const visibleSources = sources.slice(0, maxVisible);
  const extraCount = sources.length - maxVisible;

  return (
    <div className="message-sources">
      <button ref={buttonRef} className="sources-btn" title="View sources">
        <svg className="sources-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
        <span className="sources-label">Sources</span>
        <span className="sources-favicons">
          {visibleSources.map((s, i) => (
            <span key={i} className="source-favicon-wrap">
              {s.favicon ? (
                <img
                  src={s.favicon}
                  alt=""
                  className="source-favicon"
                  onError={(e) => {
                    const img = e.target as HTMLImageElement;
                    img.style.display = 'none';
                    (img.nextElementSibling as HTMLElement | null)?.classList.remove('source-favicon-fallback--hidden');
                  }}
                />
              ) : null}
              <span className={`source-favicon-fallback${s.favicon ? ' source-favicon-fallback--hidden' : ''}`}>
                {(s.title || s.link).charAt(0).toUpperCase()}
              </span>
            </span>
          ))}
          {extraCount > 0 && <span className="sources-extra">+{extraCount}</span>}
        </span>
      </button>
      <ContextMenu container={buttonRef as React.RefObject<HTMLElement | null>} showOnClick>
        {() => (
          <>
            {sources.map((s, i) => (
              <ContextMenuItem
                key={i}
                onClick={() => window.open(s.link, '_blank', 'noopener,noreferrer')}
                onAuxClick={(e) => { if (e.button === 1) { e.preventDefault(); window.open(s.link, '_blank', 'noopener,noreferrer'); } }}
                title={
                  <span className="source-menu-item">
                    <span className="source-menu-favicon-wrap">
                      {s.favicon ? (
                        <img
                          src={s.favicon}
                          alt=""
                          className="source-menu-favicon"
                          onError={(e) => {
                            const img = e.target as HTMLImageElement;
                            img.style.display = 'none';
                            (img.nextElementSibling as HTMLElement | null)?.classList.remove('source-favicon-fallback--hidden');
                          }}
                        />
                      ) : null}
                      <span className={`source-favicon-fallback source-menu-favicon-fallback${s.favicon ? ' source-favicon-fallback--hidden' : ''}`}>
                        {(s.title || s.link).charAt(0).toUpperCase()}
                      </span>
                    </span>
                    <span className="source-menu-text">
                      <span className="source-menu-title">{s.title || s.link}</span>
                      <span className="source-menu-url">{s.link}</span>
                    </span>
                    <svg className="source-menu-external" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                      <polyline points="15 3 21 3 21 9"/>
                      <line x1="10" y1="14" x2="21" y2="3"/>
                    </svg>
                  </span>
                }
              />
            ))}
          </>
        )}
      </ContextMenu>
    </div>
  );
}
